module.exports = __webpack_public_path__ + "img/rule_of_thirds_2_splash.8eb5a0fd.jpg";